export default {
  alertData: {
    show: false,
    message: '',
    type: 'error'
  },
  close() {
    Object.assign(this.alertData, { show: false, message: '' })
  },
  show(type, message) {
    Object.assign(this.alertData, { show: true, type, message })
  },
  error(msg) {
    this.close()
    this.show('error', msg)
  },
  success(msg) {
    this.show('success', msg)
  },
  warn(msg) {
    this.show('warning', msg)
  },
  addSuccess(item) {
    if (item) this.success(`Thêm mới ${item} thành công!`)
    else this.success('Thêm mới thành công!')
  },
  addError(err) {
    if (err) this.error(err)
    else this.error('Thêm thất bại')
  },
  updateSuccess(item) {
    if (item) this.success(`Cập nhật ${item} thành công!`)
    else this.success('Cập nhật thành công!')
  },
  updateError(err) {
    if (err) this.error(err)
    else this.error('Chỉnh sửa thất bại!')
  },
  deleteSuccess(item) {
    if (item) this.success(`Đã xóa ${item} thành công!`)
    else this.success(`Đã xóa thành công!`)
  },
  deleteError(err) {
    if (err) this.error(err)
    else this.error('Xóa thất bại!')
  },
  addPeriodError(err) {
    if (err) this.error(err)
    else this.error('Thêm thất bại')
  }
}
